/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/AccountResource', 'model/AccountResponse', 'model/AccountRestrictionResponse', 'model/AccountRestrictionsResponse', 'model/AccountRoleRemovedResource', 'model/AccountRoleResource', 'model/AccountsResponse', 'model/ActionToRoleResource', 'model/ApiStatisticsResponse', 'model/AreaElevationRequest', 'model/ChangePasswordResource', 'model/ClientResource', 'model/ClientResponse', 'model/ClientRoleResponse', 'model/ClientStatisticsResponse', 'model/ClientsResponse', 'model/CollectionResponseApiStatisticsResponse', 'model/CollectionResponseClientStatisticsResponse', 'model/CollectionResponseMultiItemResponseElevationsResponse', 'model/CollectionResponseMultiItemResponseGradesResponse', 'model/CollectionResponsePointResponsePointElevation', 'model/CollectionResponsePointResponseReverseGeocodingResult', 'model/CollectionResponseStatisticsResponse', 'model/ElevationConfigurationResource', 'model/ElevationResponse', 'model/ElevationsResponse', 'model/ErrorResponse', 'model/ExceptionInfo', 'model/GeoResponseLink', 'model/GradeResponse', 'model/GradesResponse', 'model/LatLonResource', 'model/LineElevationRequest', 'model/LocationResource', 'model/LoggerMessage', 'model/MenuPermissionResponse', 'model/MenuPermissionToRoleResource', 'model/MenuPermissionsResponse', 'model/MultiItemResponseElevationsResponse', 'model/MultiItemResponseGradesResponse', 'model/MultipointsElevationRequest', 'model/PermissionResponse', 'model/PermissionsResponse', 'model/PersistedGrantResource', 'model/PersistedGrantsResponse', 'model/PlaceResource', 'model/PointElevation', 'model/PointElevationRequest', 'model/PointRequest', 'model/PointResponsePointElevation', 'model/PointResponseReverseGeocodingResult', 'model/RegisterAccountResource', 'model/ResponseAccountResponse', 'model/ResponseAccountRestrictionResponse', 'model/ResponseClientResponse', 'model/ResponseCollectionLoggerMessage', 'model/ResponseCollectionString', 'model/ResponseDictionaryStringString', 'model/ResponseElevationConfigurationResource', 'model/ResponseListClientRoleResponse', 'model/ResponseListRestrictionActionResource', 'model/ResponseListString', 'model/ResponseLocationResource', 'model/ResponseObject', 'model/ResponsePlaceResource', 'model/ResponsePointElevation', 'model/ResponseRestrictionResponse', 'model/ResponseReverseGeocodingResult', 'model/ResponseRoleResponse', 'model/ResponseRoleToAccountResponse', 'model/ResponseWorldImagerySettingsResource', 'model/ResponseWorldStreetsSettingsResource', 'model/RestrictionActionResource', 'model/RestrictionResource', 'model/RestrictionResponse', 'model/RestrictionsResponse', 'model/ReverseGeocodingConfigurationResource', 'model/ReverseGeocodingResult', 'model/RoleActionResource', 'model/RoleResource', 'model/RoleResponse', 'model/RoleToAccountResponse', 'model/RolesResponse', 'model/RolesToAccountResponse', 'model/StatisticsResponse', 'model/WorldImagerySettingsResource', 'model/WorldStreetsSettingsResource', 'api/AccountsApi', 'api/AuthApi', 'api/ClientsApi', 'api/ElevationApi', 'api/ElevationSettingsApi', 'api/LoggersApi', 'api/MenuPermissionApi', 'api/PermissionsApi', 'api/RestrictionApi', 'api/ReverseGeocodingApi', 'api/ReverseGeocodingSettingsApi', 'api/RolesApi', 'api/SettingsApi', 'api/StatisticsApi', 'api/TimeZoneApi', 'api/WorldImageryApi', 'api/WorldImagerySettingsApi', 'api/WorldStreetsApi', 'api/WorldStreetsSettingsApi'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('./ApiClient'), require('./model/AccountResource'), require('./model/AccountResponse'), require('./model/AccountRestrictionResponse'), require('./model/AccountRestrictionsResponse'), require('./model/AccountRoleRemovedResource'), require('./model/AccountRoleResource'), require('./model/AccountsResponse'), require('./model/ActionToRoleResource'), require('./model/ApiStatisticsResponse'), require('./model/AreaElevationRequest'), require('./model/ChangePasswordResource'), require('./model/ClientResource'), require('./model/ClientResponse'), require('./model/ClientRoleResponse'), require('./model/ClientStatisticsResponse'), require('./model/ClientsResponse'), require('./model/CollectionResponseApiStatisticsResponse'), require('./model/CollectionResponseClientStatisticsResponse'), require('./model/CollectionResponseMultiItemResponseElevationsResponse'), require('./model/CollectionResponseMultiItemResponseGradesResponse'), require('./model/CollectionResponsePointResponsePointElevation'), require('./model/CollectionResponsePointResponseReverseGeocodingResult'), require('./model/CollectionResponseStatisticsResponse'), require('./model/ElevationConfigurationResource'), require('./model/ElevationResponse'), require('./model/ElevationsResponse'), require('./model/ErrorResponse'), require('./model/ExceptionInfo'), require('./model/GeoResponseLink'), require('./model/GradeResponse'), require('./model/GradesResponse'), require('./model/LatLonResource'), require('./model/LineElevationRequest'), require('./model/LocationResource'), require('./model/LoggerMessage'), require('./model/MenuPermissionResponse'), require('./model/MenuPermissionToRoleResource'), require('./model/MenuPermissionsResponse'), require('./model/MultiItemResponseElevationsResponse'), require('./model/MultiItemResponseGradesResponse'), require('./model/MultipointsElevationRequest'), require('./model/PermissionResponse'), require('./model/PermissionsResponse'), require('./model/PersistedGrantResource'), require('./model/PersistedGrantsResponse'), require('./model/PlaceResource'), require('./model/PointElevation'), require('./model/PointElevationRequest'), require('./model/PointRequest'), require('./model/PointResponsePointElevation'), require('./model/PointResponseReverseGeocodingResult'), require('./model/RegisterAccountResource'), require('./model/ResponseAccountResponse'), require('./model/ResponseAccountRestrictionResponse'), require('./model/ResponseClientResponse'), require('./model/ResponseCollectionLoggerMessage'), require('./model/ResponseCollectionString'), require('./model/ResponseDictionaryStringString'), require('./model/ResponseElevationConfigurationResource'), require('./model/ResponseListClientRoleResponse'), require('./model/ResponseListRestrictionActionResource'), require('./model/ResponseListString'), require('./model/ResponseLocationResource'), require('./model/ResponseObject'), require('./model/ResponsePlaceResource'), require('./model/ResponsePointElevation'), require('./model/ResponseRestrictionResponse'), require('./model/ResponseReverseGeocodingResult'), require('./model/ResponseRoleResponse'), require('./model/ResponseRoleToAccountResponse'), require('./model/ResponseWorldImagerySettingsResource'), require('./model/ResponseWorldStreetsSettingsResource'), require('./model/RestrictionActionResource'), require('./model/RestrictionResource'), require('./model/RestrictionResponse'), require('./model/RestrictionsResponse'), require('./model/ReverseGeocodingConfigurationResource'), require('./model/ReverseGeocodingResult'), require('./model/RoleActionResource'), require('./model/RoleResource'), require('./model/RoleResponse'), require('./model/RoleToAccountResponse'), require('./model/RolesResponse'), require('./model/RolesToAccountResponse'), require('./model/StatisticsResponse'), require('./model/WorldImagerySettingsResource'), require('./model/WorldStreetsSettingsResource'), require('./api/AccountsApi'), require('./api/AuthApi'), require('./api/ClientsApi'), require('./api/ElevationApi'), require('./api/ElevationSettingsApi'), require('./api/LoggersApi'), require('./api/MenuPermissionApi'), require('./api/PermissionsApi'), require('./api/RestrictionApi'), require('./api/ReverseGeocodingApi'), require('./api/ReverseGeocodingSettingsApi'), require('./api/RolesApi'), require('./api/SettingsApi'), require('./api/StatisticsApi'), require('./api/TimeZoneApi'), require('./api/WorldImageryApi'), require('./api/WorldImagerySettingsApi'), require('./api/WorldStreetsApi'), require('./api/WorldStreetsSettingsApi'));
  }
}(function(ApiClient, AccountResource, AccountResponse, AccountRestrictionResponse, AccountRestrictionsResponse, AccountRoleRemovedResource, AccountRoleResource, AccountsResponse, ActionToRoleResource, ApiStatisticsResponse, AreaElevationRequest, ChangePasswordResource, ClientResource, ClientResponse, ClientRoleResponse, ClientStatisticsResponse, ClientsResponse, CollectionResponseApiStatisticsResponse, CollectionResponseClientStatisticsResponse, CollectionResponseMultiItemResponseElevationsResponse, CollectionResponseMultiItemResponseGradesResponse, CollectionResponsePointResponsePointElevation, CollectionResponsePointResponseReverseGeocodingResult, CollectionResponseStatisticsResponse, ElevationConfigurationResource, ElevationResponse, ElevationsResponse, ErrorResponse, ExceptionInfo, GeoResponseLink, GradeResponse, GradesResponse, LatLonResource, LineElevationRequest, LocationResource, LoggerMessage, MenuPermissionResponse, MenuPermissionToRoleResource, MenuPermissionsResponse, MultiItemResponseElevationsResponse, MultiItemResponseGradesResponse, MultipointsElevationRequest, PermissionResponse, PermissionsResponse, PersistedGrantResource, PersistedGrantsResponse, PlaceResource, PointElevation, PointElevationRequest, PointRequest, PointResponsePointElevation, PointResponseReverseGeocodingResult, RegisterAccountResource, ResponseAccountResponse, ResponseAccountRestrictionResponse, ResponseClientResponse, ResponseCollectionLoggerMessage, ResponseCollectionString, ResponseDictionaryStringString, ResponseElevationConfigurationResource, ResponseListClientRoleResponse, ResponseListRestrictionActionResource, ResponseListString, ResponseLocationResource, ResponseObject, ResponsePlaceResource, ResponsePointElevation, ResponseRestrictionResponse, ResponseReverseGeocodingResult, ResponseRoleResponse, ResponseRoleToAccountResponse, ResponseWorldImagerySettingsResource, ResponseWorldStreetsSettingsResource, RestrictionActionResource, RestrictionResource, RestrictionResponse, RestrictionsResponse, ReverseGeocodingConfigurationResource, ReverseGeocodingResult, RoleActionResource, RoleResource, RoleResponse, RoleToAccountResponse, RolesResponse, RolesToAccountResponse, StatisticsResponse, WorldImagerySettingsResource, WorldStreetsSettingsResource, AccountsApi, AuthApi, ClientsApi, ElevationApi, ElevationSettingsApi, LoggersApi, MenuPermissionApi, PermissionsApi, RestrictionApi, ReverseGeocodingApi, ReverseGeocodingSettingsApi, RolesApi, SettingsApi, StatisticsApi, TimeZoneApi, WorldImageryApi, WorldImagerySettingsApi, WorldStreetsApi, WorldStreetsSettingsApi) {
  'use strict';

  /**
   * A powerful suite of mapping, geospatial and location-based APIs for your applications and services..<br>
   * The <code>index</code> module provides access to constructors for all the classes which comprise the public API.
   * <p>
   * An AMD (recommended!) or CommonJS application will generally do something equivalent to the following:
   * <pre>
   * var GisServerApis = require('index'); // See note below*.
   * var xxxSvc = new GisServerApis.XxxApi(); // Allocate the API class we're going to use.
   * var yyyModel = new GisServerApis.Yyy(); // Construct a model instance.
   * yyyModel.someProperty = 'someValue';
   * ...
   * var zzz = xxxSvc.doSomething(yyyModel); // Invoke the service.
   * ...
   * </pre>
   * <em>*NOTE: For a top-level AMD script, use require(['index'], function(){...})
   * and put the application logic within the callback function.</em>
   * </p>
   * <p>
   * A non-AMD browser application (discouraged) might do something like this:
   * <pre>
   * var xxxSvc = new GisServerApis.XxxApi(); // Allocate the API class we're going to use.
   * var yyy = new GisServerApis.Yyy(); // Construct a model instance.
   * yyyModel.someProperty = 'someValue';
   * ...
   * var zzz = xxxSvc.doSomething(yyyModel); // Invoke the service.
   * ...
   * </pre>
   * </p>
   * @module index
   * @version 1.0.0
   */
  var exports = {
    /**
     * The ApiClient constructor.
     * @property {module:ApiClient}
     */
    ApiClient: ApiClient,
    /**
     * The AccountResource model constructor.
     * @property {module:model/AccountResource}
     */
    AccountResource: AccountResource,
    /**
     * The AccountResponse model constructor.
     * @property {module:model/AccountResponse}
     */
    AccountResponse: AccountResponse,
    /**
     * The AccountRestrictionResponse model constructor.
     * @property {module:model/AccountRestrictionResponse}
     */
    AccountRestrictionResponse: AccountRestrictionResponse,
    /**
     * The AccountRestrictionsResponse model constructor.
     * @property {module:model/AccountRestrictionsResponse}
     */
    AccountRestrictionsResponse: AccountRestrictionsResponse,
    /**
     * The AccountRoleRemovedResource model constructor.
     * @property {module:model/AccountRoleRemovedResource}
     */
    AccountRoleRemovedResource: AccountRoleRemovedResource,
    /**
     * The AccountRoleResource model constructor.
     * @property {module:model/AccountRoleResource}
     */
    AccountRoleResource: AccountRoleResource,
    /**
     * The AccountsResponse model constructor.
     * @property {module:model/AccountsResponse}
     */
    AccountsResponse: AccountsResponse,
    /**
     * The ActionToRoleResource model constructor.
     * @property {module:model/ActionToRoleResource}
     */
    ActionToRoleResource: ActionToRoleResource,
    /**
     * The ApiStatisticsResponse model constructor.
     * @property {module:model/ApiStatisticsResponse}
     */
    ApiStatisticsResponse: ApiStatisticsResponse,
    /**
     * The AreaElevationRequest model constructor.
     * @property {module:model/AreaElevationRequest}
     */
    AreaElevationRequest: AreaElevationRequest,
    /**
     * The ChangePasswordResource model constructor.
     * @property {module:model/ChangePasswordResource}
     */
    ChangePasswordResource: ChangePasswordResource,
    /**
     * The ClientResource model constructor.
     * @property {module:model/ClientResource}
     */
    ClientResource: ClientResource,
    /**
     * The ClientResponse model constructor.
     * @property {module:model/ClientResponse}
     */
    ClientResponse: ClientResponse,
    /**
     * The ClientRoleResponse model constructor.
     * @property {module:model/ClientRoleResponse}
     */
    ClientRoleResponse: ClientRoleResponse,
    /**
     * The ClientStatisticsResponse model constructor.
     * @property {module:model/ClientStatisticsResponse}
     */
    ClientStatisticsResponse: ClientStatisticsResponse,
    /**
     * The ClientsResponse model constructor.
     * @property {module:model/ClientsResponse}
     */
    ClientsResponse: ClientsResponse,
    /**
     * The CollectionResponseApiStatisticsResponse model constructor.
     * @property {module:model/CollectionResponseApiStatisticsResponse}
     */
    CollectionResponseApiStatisticsResponse: CollectionResponseApiStatisticsResponse,
    /**
     * The CollectionResponseClientStatisticsResponse model constructor.
     * @property {module:model/CollectionResponseClientStatisticsResponse}
     */
    CollectionResponseClientStatisticsResponse: CollectionResponseClientStatisticsResponse,
    /**
     * The CollectionResponseMultiItemResponseElevationsResponse model constructor.
     * @property {module:model/CollectionResponseMultiItemResponseElevationsResponse}
     */
    CollectionResponseMultiItemResponseElevationsResponse: CollectionResponseMultiItemResponseElevationsResponse,
    /**
     * The CollectionResponseMultiItemResponseGradesResponse model constructor.
     * @property {module:model/CollectionResponseMultiItemResponseGradesResponse}
     */
    CollectionResponseMultiItemResponseGradesResponse: CollectionResponseMultiItemResponseGradesResponse,
    /**
     * The CollectionResponsePointResponsePointElevation model constructor.
     * @property {module:model/CollectionResponsePointResponsePointElevation}
     */
    CollectionResponsePointResponsePointElevation: CollectionResponsePointResponsePointElevation,
    /**
     * The CollectionResponsePointResponseReverseGeocodingResult model constructor.
     * @property {module:model/CollectionResponsePointResponseReverseGeocodingResult}
     */
    CollectionResponsePointResponseReverseGeocodingResult: CollectionResponsePointResponseReverseGeocodingResult,
    /**
     * The CollectionResponseStatisticsResponse model constructor.
     * @property {module:model/CollectionResponseStatisticsResponse}
     */
    CollectionResponseStatisticsResponse: CollectionResponseStatisticsResponse,
    /**
     * The ElevationConfigurationResource model constructor.
     * @property {module:model/ElevationConfigurationResource}
     */
    ElevationConfigurationResource: ElevationConfigurationResource,
    /**
     * The ElevationResponse model constructor.
     * @property {module:model/ElevationResponse}
     */
    ElevationResponse: ElevationResponse,
    /**
     * The ElevationsResponse model constructor.
     * @property {module:model/ElevationsResponse}
     */
    ElevationsResponse: ElevationsResponse,
    /**
     * The ErrorResponse model constructor.
     * @property {module:model/ErrorResponse}
     */
    ErrorResponse: ErrorResponse,
    /**
     * The ExceptionInfo model constructor.
     * @property {module:model/ExceptionInfo}
     */
    ExceptionInfo: ExceptionInfo,
    /**
     * The GeoResponseLink model constructor.
     * @property {module:model/GeoResponseLink}
     */
    GeoResponseLink: GeoResponseLink,
    /**
     * The GradeResponse model constructor.
     * @property {module:model/GradeResponse}
     */
    GradeResponse: GradeResponse,
    /**
     * The GradesResponse model constructor.
     * @property {module:model/GradesResponse}
     */
    GradesResponse: GradesResponse,
    /**
     * The LatLonResource model constructor.
     * @property {module:model/LatLonResource}
     */
    LatLonResource: LatLonResource,
    /**
     * The LineElevationRequest model constructor.
     * @property {module:model/LineElevationRequest}
     */
    LineElevationRequest: LineElevationRequest,
    /**
     * The LocationResource model constructor.
     * @property {module:model/LocationResource}
     */
    LocationResource: LocationResource,
    /**
     * The LoggerMessage model constructor.
     * @property {module:model/LoggerMessage}
     */
    LoggerMessage: LoggerMessage,
    /**
     * The MenuPermissionResponse model constructor.
     * @property {module:model/MenuPermissionResponse}
     */
    MenuPermissionResponse: MenuPermissionResponse,
    /**
     * The MenuPermissionToRoleResource model constructor.
     * @property {module:model/MenuPermissionToRoleResource}
     */
    MenuPermissionToRoleResource: MenuPermissionToRoleResource,
    /**
     * The MenuPermissionsResponse model constructor.
     * @property {module:model/MenuPermissionsResponse}
     */
    MenuPermissionsResponse: MenuPermissionsResponse,
    /**
     * The MultiItemResponseElevationsResponse model constructor.
     * @property {module:model/MultiItemResponseElevationsResponse}
     */
    MultiItemResponseElevationsResponse: MultiItemResponseElevationsResponse,
    /**
     * The MultiItemResponseGradesResponse model constructor.
     * @property {module:model/MultiItemResponseGradesResponse}
     */
    MultiItemResponseGradesResponse: MultiItemResponseGradesResponse,
    /**
     * The MultipointsElevationRequest model constructor.
     * @property {module:model/MultipointsElevationRequest}
     */
    MultipointsElevationRequest: MultipointsElevationRequest,
    /**
     * The PermissionResponse model constructor.
     * @property {module:model/PermissionResponse}
     */
    PermissionResponse: PermissionResponse,
    /**
     * The PermissionsResponse model constructor.
     * @property {module:model/PermissionsResponse}
     */
    PermissionsResponse: PermissionsResponse,
    /**
     * The PersistedGrantResource model constructor.
     * @property {module:model/PersistedGrantResource}
     */
    PersistedGrantResource: PersistedGrantResource,
    /**
     * The PersistedGrantsResponse model constructor.
     * @property {module:model/PersistedGrantsResponse}
     */
    PersistedGrantsResponse: PersistedGrantsResponse,
    /**
     * The PlaceResource model constructor.
     * @property {module:model/PlaceResource}
     */
    PlaceResource: PlaceResource,
    /**
     * The PointElevation model constructor.
     * @property {module:model/PointElevation}
     */
    PointElevation: PointElevation,
    /**
     * The PointElevationRequest model constructor.
     * @property {module:model/PointElevationRequest}
     */
    PointElevationRequest: PointElevationRequest,
    /**
     * The PointRequest model constructor.
     * @property {module:model/PointRequest}
     */
    PointRequest: PointRequest,
    /**
     * The PointResponsePointElevation model constructor.
     * @property {module:model/PointResponsePointElevation}
     */
    PointResponsePointElevation: PointResponsePointElevation,
    /**
     * The PointResponseReverseGeocodingResult model constructor.
     * @property {module:model/PointResponseReverseGeocodingResult}
     */
    PointResponseReverseGeocodingResult: PointResponseReverseGeocodingResult,
    /**
     * The RegisterAccountResource model constructor.
     * @property {module:model/RegisterAccountResource}
     */
    RegisterAccountResource: RegisterAccountResource,
    /**
     * The ResponseAccountResponse model constructor.
     * @property {module:model/ResponseAccountResponse}
     */
    ResponseAccountResponse: ResponseAccountResponse,
    /**
     * The ResponseAccountRestrictionResponse model constructor.
     * @property {module:model/ResponseAccountRestrictionResponse}
     */
    ResponseAccountRestrictionResponse: ResponseAccountRestrictionResponse,
    /**
     * The ResponseClientResponse model constructor.
     * @property {module:model/ResponseClientResponse}
     */
    ResponseClientResponse: ResponseClientResponse,
    /**
     * The ResponseCollectionLoggerMessage model constructor.
     * @property {module:model/ResponseCollectionLoggerMessage}
     */
    ResponseCollectionLoggerMessage: ResponseCollectionLoggerMessage,
    /**
     * The ResponseCollectionString model constructor.
     * @property {module:model/ResponseCollectionString}
     */
    ResponseCollectionString: ResponseCollectionString,
    /**
     * The ResponseDictionaryStringString model constructor.
     * @property {module:model/ResponseDictionaryStringString}
     */
    ResponseDictionaryStringString: ResponseDictionaryStringString,
    /**
     * The ResponseElevationConfigurationResource model constructor.
     * @property {module:model/ResponseElevationConfigurationResource}
     */
    ResponseElevationConfigurationResource: ResponseElevationConfigurationResource,
    /**
     * The ResponseListClientRoleResponse model constructor.
     * @property {module:model/ResponseListClientRoleResponse}
     */
    ResponseListClientRoleResponse: ResponseListClientRoleResponse,
    /**
     * The ResponseListRestrictionActionResource model constructor.
     * @property {module:model/ResponseListRestrictionActionResource}
     */
    ResponseListRestrictionActionResource: ResponseListRestrictionActionResource,
    /**
     * The ResponseListString model constructor.
     * @property {module:model/ResponseListString}
     */
    ResponseListString: ResponseListString,
    /**
     * The ResponseLocationResource model constructor.
     * @property {module:model/ResponseLocationResource}
     */
    ResponseLocationResource: ResponseLocationResource,
    /**
     * The ResponseObject model constructor.
     * @property {module:model/ResponseObject}
     */
    ResponseObject: ResponseObject,
    /**
     * The ResponsePlaceResource model constructor.
     * @property {module:model/ResponsePlaceResource}
     */
    ResponsePlaceResource: ResponsePlaceResource,
    /**
     * The ResponsePointElevation model constructor.
     * @property {module:model/ResponsePointElevation}
     */
    ResponsePointElevation: ResponsePointElevation,
    /**
     * The ResponseRestrictionResponse model constructor.
     * @property {module:model/ResponseRestrictionResponse}
     */
    ResponseRestrictionResponse: ResponseRestrictionResponse,
    /**
     * The ResponseReverseGeocodingResult model constructor.
     * @property {module:model/ResponseReverseGeocodingResult}
     */
    ResponseReverseGeocodingResult: ResponseReverseGeocodingResult,
    /**
     * The ResponseRoleResponse model constructor.
     * @property {module:model/ResponseRoleResponse}
     */
    ResponseRoleResponse: ResponseRoleResponse,
    /**
     * The ResponseRoleToAccountResponse model constructor.
     * @property {module:model/ResponseRoleToAccountResponse}
     */
    ResponseRoleToAccountResponse: ResponseRoleToAccountResponse,
    /**
     * The ResponseWorldImagerySettingsResource model constructor.
     * @property {module:model/ResponseWorldImagerySettingsResource}
     */
    ResponseWorldImagerySettingsResource: ResponseWorldImagerySettingsResource,
    /**
     * The ResponseWorldStreetsSettingsResource model constructor.
     * @property {module:model/ResponseWorldStreetsSettingsResource}
     */
    ResponseWorldStreetsSettingsResource: ResponseWorldStreetsSettingsResource,
    /**
     * The RestrictionActionResource model constructor.
     * @property {module:model/RestrictionActionResource}
     */
    RestrictionActionResource: RestrictionActionResource,
    /**
     * The RestrictionResource model constructor.
     * @property {module:model/RestrictionResource}
     */
    RestrictionResource: RestrictionResource,
    /**
     * The RestrictionResponse model constructor.
     * @property {module:model/RestrictionResponse}
     */
    RestrictionResponse: RestrictionResponse,
    /**
     * The RestrictionsResponse model constructor.
     * @property {module:model/RestrictionsResponse}
     */
    RestrictionsResponse: RestrictionsResponse,
    /**
     * The ReverseGeocodingConfigurationResource model constructor.
     * @property {module:model/ReverseGeocodingConfigurationResource}
     */
    ReverseGeocodingConfigurationResource: ReverseGeocodingConfigurationResource,
    /**
     * The ReverseGeocodingResult model constructor.
     * @property {module:model/ReverseGeocodingResult}
     */
    ReverseGeocodingResult: ReverseGeocodingResult,
    /**
     * The RoleActionResource model constructor.
     * @property {module:model/RoleActionResource}
     */
    RoleActionResource: RoleActionResource,
    /**
     * The RoleResource model constructor.
     * @property {module:model/RoleResource}
     */
    RoleResource: RoleResource,
    /**
     * The RoleResponse model constructor.
     * @property {module:model/RoleResponse}
     */
    RoleResponse: RoleResponse,
    /**
     * The RoleToAccountResponse model constructor.
     * @property {module:model/RoleToAccountResponse}
     */
    RoleToAccountResponse: RoleToAccountResponse,
    /**
     * The RolesResponse model constructor.
     * @property {module:model/RolesResponse}
     */
    RolesResponse: RolesResponse,
    /**
     * The RolesToAccountResponse model constructor.
     * @property {module:model/RolesToAccountResponse}
     */
    RolesToAccountResponse: RolesToAccountResponse,
    /**
     * The StatisticsResponse model constructor.
     * @property {module:model/StatisticsResponse}
     */
    StatisticsResponse: StatisticsResponse,
    /**
     * The WorldImagerySettingsResource model constructor.
     * @property {module:model/WorldImagerySettingsResource}
     */
    WorldImagerySettingsResource: WorldImagerySettingsResource,
    /**
     * The WorldStreetsSettingsResource model constructor.
     * @property {module:model/WorldStreetsSettingsResource}
     */
    WorldStreetsSettingsResource: WorldStreetsSettingsResource,
    /**
     * The AccountsApi service constructor.
     * @property {module:api/AccountsApi}
     */
    AccountsApi: AccountsApi,
    /**
     * The AuthApi service constructor.
     * @property {module:api/AuthApi}
     */
    AuthApi: AuthApi,
    /**
     * The ClientsApi service constructor.
     * @property {module:api/ClientsApi}
     */
    ClientsApi: ClientsApi,
    /**
     * The ElevationApi service constructor.
     * @property {module:api/ElevationApi}
     */
    ElevationApi: ElevationApi,
    /**
     * The ElevationSettingsApi service constructor.
     * @property {module:api/ElevationSettingsApi}
     */
    ElevationSettingsApi: ElevationSettingsApi,
    /**
     * The LoggersApi service constructor.
     * @property {module:api/LoggersApi}
     */
    LoggersApi: LoggersApi,
    /**
     * The MenuPermissionApi service constructor.
     * @property {module:api/MenuPermissionApi}
     */
    MenuPermissionApi: MenuPermissionApi,
    /**
     * The PermissionsApi service constructor.
     * @property {module:api/PermissionsApi}
     */
    PermissionsApi: PermissionsApi,
    /**
     * The RestrictionApi service constructor.
     * @property {module:api/RestrictionApi}
     */
    RestrictionApi: RestrictionApi,
    /**
     * The ReverseGeocodingApi service constructor.
     * @property {module:api/ReverseGeocodingApi}
     */
    ReverseGeocodingApi: ReverseGeocodingApi,
    /**
     * The ReverseGeocodingSettingsApi service constructor.
     * @property {module:api/ReverseGeocodingSettingsApi}
     */
    ReverseGeocodingSettingsApi: ReverseGeocodingSettingsApi,
    /**
     * The RolesApi service constructor.
     * @property {module:api/RolesApi}
     */
    RolesApi: RolesApi,
    /**
     * The SettingsApi service constructor.
     * @property {module:api/SettingsApi}
     */
    SettingsApi: SettingsApi,
    /**
     * The StatisticsApi service constructor.
     * @property {module:api/StatisticsApi}
     */
    StatisticsApi: StatisticsApi,
    /**
     * The TimeZoneApi service constructor.
     * @property {module:api/TimeZoneApi}
     */
    TimeZoneApi: TimeZoneApi,
    /**
     * The WorldImageryApi service constructor.
     * @property {module:api/WorldImageryApi}
     */
    WorldImageryApi: WorldImageryApi,
    /**
     * The WorldImagerySettingsApi service constructor.
     * @property {module:api/WorldImagerySettingsApi}
     */
    WorldImagerySettingsApi: WorldImagerySettingsApi,
    /**
     * The WorldStreetsApi service constructor.
     * @property {module:api/WorldStreetsApi}
     */
    WorldStreetsApi: WorldStreetsApi,
    /**
     * The WorldStreetsSettingsApi service constructor.
     * @property {module:api/WorldStreetsSettingsApi}
     */
    WorldStreetsSettingsApi: WorldStreetsSettingsApi
  };

  return exports;
}));

